/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Connect_FirstInputs */

const en_domain_manager_connect_first = /** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Connect your first domain`)
};

const es_domain_manager_connect_first = /** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Conecta tu primer dominio`)
};

const fr_domain_manager_connect_first = /** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Connecter votre premier domaine`)
};

const de_domain_manager_connect_first = /** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Verbinde deine erste Domain`)
};

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const ja_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const zh_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const ar_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const id_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const it_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const ru_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const pt_domain_manager_connect_first = en_domain_manager_connect_first;

/** @type {(inputs: Domain_Manager_Connect_FirstInputs) => LocalizedString} */
const ko_domain_manager_connect_first = en_domain_manager_connect_first;

/**
* | output |
* | --- |
* | "+ Connect your first domain" |
*
* @param {Domain_Manager_Connect_FirstInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_connect_first = /** @type {((inputs?: Domain_Manager_Connect_FirstInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Connect_FirstInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_connect_first(inputs)
	if (locale === "es") return es_domain_manager_connect_first(inputs)
	if (locale === "fr") return fr_domain_manager_connect_first(inputs)
	if (locale === "de") return de_domain_manager_connect_first(inputs)
	if (locale === "ja") return ja_domain_manager_connect_first(inputs)
	if (locale === "zh") return zh_domain_manager_connect_first(inputs)
	if (locale === "ar") return ar_domain_manager_connect_first(inputs)
	if (locale === "id") return id_domain_manager_connect_first(inputs)
	if (locale === "it") return it_domain_manager_connect_first(inputs)
	if (locale === "ru") return ru_domain_manager_connect_first(inputs)
	if (locale === "pt") return pt_domain_manager_connect_first(inputs)
	return ko_domain_manager_connect_first(inputs)
});